<script setup lang="ts">
const appearanceStore = useAppearanceStore();
const { isMobile } = useLayout();
const { customSealsOnPatronages } = useLicenses();
const { hideExternalLinks } = useLinks();

const sponsors = computed(() => {
  return appearanceStore.appearance.sponsorships;
});

const hasCustomSeals = computed<boolean>(() => {
  return customSealsOnPatronages.value && customSealsOnPatronages.value?.length;
});
</script>

<template>
  <div
    v-if="sponsors && sponsors.length"
    :class="$style.patronageSection"
  >
    <div :class="$style.patronageWrapper">
      <div :class="hasCustomSeals ? $style.withSeal : $style.noSeal">
        <NuxtLink
          class="mb-1 xl:mb-2"
          :class="[$style.sectionTitle, $style.mainTitle]"
          no-prefetch
          to="/sponsors"
        >
          <span v-html="$t('footer.sponsor')" />
        </NuxtLink>

        <div :class="$style.items">
          <template v-if="sponsors?.length">
            <FooterItemsPatronage
              v-for="sponsor in sponsors"
              :key="sponsor.id"
              :height="isMobile ? 80 : 85"
              :href="!hideExternalLinks ? sponsor.page_url : ''"
              :image="getUrlForApiImage(sponsor.icon) || ''"
              :rounded="false"
              :title="sponsor.name"
              :width="isMobile ? 80 : 85"
            />
          </template>
        </div>
      </div>

      <div
        v-if="hasCustomSeals"
        :class="$style.sealDivisor"
      >
      </div>

      <div
        v-if="customSealsOnPatronages?.length"
        :class="$style.awardsSection"
      >
        <p
          class="mb-4 xl:mb-0"
          :class="$style.sectionTitle"
          v-html="$t('footer.awards_title', { name: appName() })"
        >
        </p>

        <FooterItemsAwardsAndSeals />
      </div>
    </div>
  </div>
</template>

<style module lang="scss">
.patronageSection {
  @apply w-full flex items-center flex-col py-4 xl:py-8 px-0 md:px-2 relative;

  &:after {
    @apply content-[''] w-full h-px bg-footer-texts absolute top-full left-0 opacity-15;
  }
}

.patronageWrapper {
  @apply flex flex-col xl:flex-row w-full justify-center items-center gap-4 xl:gap-10;

  .noSeal {
    @apply flex flex-col items-center gap-0 xl:flex-row xl:gap-4;

    .mainTitle {
      @apply xl:text-left;
    }
  }

  .withSeal {
    @apply w-full gap-4 xl:w-auto xl:flex xl:items-center xl:gap-4;
  }

  .sealDivisor {
    @apply hidden relative w-0.5 rounded h-24 bg-footer-texts/20 xl:block;
  }

  .items {
    @apply flex justify-center xl:justify-start;
  }
}

.awardsSection {
  @apply relative w-full pt-4 xl:mt-0 xl:pt-0 xl:pb-3 xl:w-auto xl:flex xl:items-center xl:gap-4;

  &:before {
    @apply content-[''] w-full h-px bg-footer-texts absolute top-0 left-0 opacity-15 xl:opacity-0;
  }
}

.sectionTitle {
  @apply text-footer-titles text-center text-xs xl:text-left uppercase whitespace-nowrap font-semibold -mb-1 md:mb-0;

  &.mainTitle {
    @apply flex justify-center;
  }

  small {
    @apply text-2xs text-footer-titles/40;
  }
}
</style>
